const devMode = false;

const outOfStockWarningP = document.getElementById("outOfStockWarningP");
const outOfStockModelsSpan = document.getElementById("outOfStockModelsSpan");

const yourModelTitleClass = "YourModelText";
const newModelTitleClass = "YourRequestedModelText";

const lowStockTreshold = 5;
const templatesWrapper = document.getElementById("templatesWrapper");
const typeSelectionSlide = document.getElementById("typeSelectionSlide");
const returnInSizeSelectionSlide = document.getElementById("returnInSizeSelectionSlide");
const wrongArticleQuestionSlide = document.getElementById("wrongArticleQuestionSlide");
const articleSelectionSlide = document.getElementById("articleSelectionSlide");
const returnQuestionOneSlide = document.getElementById("returnQuestionOneSlide");
const returnQuestionTwoSlide = document.getElementById("returnQuestionTwoSlide");
const returnQuestionThreeSlide = document.getElementById("returnQuestionThreeSlide");
const returnQuestionThreeOtherSlide = document.getElementById("returnQuestionThreeOtherSlide");
const warrantyQuestionOneSlide = document.getElementById("warrantyQuestionOneSlide");
const boArtExchangeModelSelectionSlide = document.getElementById("boArtExchangeModelSelectionSlide");
const exchangeModelSelectionSlide = document.getElementById("exchangeModelSelectionSlide");
const exchangeSizeSelectionSlide = document.getElementById("exchangeSizeSelectionSlide");
const exchangeModelReasonSlide = document.getElementById("exchangeModelReasonSlide");
const customerInformationSlide = document.getElementById("customerInformationSlide");
const imagesSlide = document.getElementById("imagesSlide");
const finalCheckSlide = document.getElementById("finalCheckSlide");
const requestCreatedSlide = document.getElementById("requestCreatedSlide");
const requestFailedSlide = document.getElementById("requestFailedSlide");

const selectedClassName = "selectedReturnRow";

const baseCdnPath = splitLastOccurrence('//royer.com/cdn/shop/files/royer-favicon_small.png?v=1787115176', "/")[0] + "/";
const maxDaysReturnExchange = 60;
const maxDaysWarranty = 182.5;

const divSteps = document.getElementsByClassName("divSteps");

const emailInput = document.getElementById("emailInput");
const modelSelect = document.getElementById("modelSelect");

const typeSelectWrapper = document.getElementById("typeSelectWrapper");
let returnType = "";
let returnReason;

let stockArticles;
let articles;

const articleSelectionTitlesWrapper = document.getElementById("articleSelectionTitlesWrapper");
const returnInArticleWrapper = document.getElementById("returnInArticleWrapper");

const returnInSizeSelectionArticleBox = document.getElementById("returnInSizeSelectionArticleBox");
const returnInSizeSelectionSection = document.getElementById("returnInSizeSelectionSection");
const returnInSizeSelection = document.getElementById("returnInSizeSelection");
const returnInWidthSelectionSection = document.getElementById("returnInWidthSelectionSection");
const returnInWidthSelection = document.getElementById("returnInWidthSelection");

const returnQuestionOneArticleBox = document.getElementById("returnQuestionOneArticleBox");
const returnQuestionTwoArticleBox = document.getElementById("returnQuestionTwoArticleBox");
const returnQuestionThreeArticleBox = document.getElementById("returnQuestionThreeArticleBox");
const returnQuestionThreeOtherArticleBox = document.getElementById("returnQuestionThreeOtherArticleBox");
const warrantyQuestionOneArticleBox = document.getElementById("warrantyQuestionOneArticleBox");
const imageArticleBox = document.getElementById("imageArticleBox");

const returnQuestionThreeWrapper = document.getElementById("returnQuestionThreeWrapper");
const returnQuestionThreeOtherTitle = document.getElementById("returnQuestionThreeOtherTitle");


const boArtExchangeModelSelectionArticleBox = document.getElementById("boArtExchangeModelSelectionArticleBox");
const boArtNewModelSelectWrapper = document.getElementById("boArtNewModelSelectWrapper");
const boArtNewModelSelect = document.getElementById("boArtNewModelSelect")

const exchangeModelSelectionArticleBox = document.getElementById("exchangeModelSelectionArticleBox");
const newModelSelectWrapper = document.getElementById("newModelSelectWrapper");
const newModelSelect = document.getElementById("newModelSelect")

const exchangeModelReasonArticleBox = document.getElementById("exchangeModelReasonArticleBox");

const exchangeSizeSelectionArticleBox = document.getElementById("exchangeSizeSelectionArticleBox");
const exchangeSizeSelectionSection = document.getElementById("exchangeSizeSelectionSection");
const exchangeSizeSelection = document.getElementById("exchangeSizeSelection");
const exchangeWidthSelectionSection = document.getElementById("exchangeWidthSelectionSection");
const exchangeWidthSelection = document.getElementById("exchangeWidthSelection");

const wrongBootsSizeSelectionArticleBox = document.getElementById("wrongBootsSizeSelectionArticleBox");
const wrongBootsSizeSelectionSection = document.getElementById("wrongBootsSizeSelectionSection");
const wrongBootsSizeSelection = document.getElementById("wrongBootsSizeSelection");
const wrongBootsWidthSelectionSection = document.getElementById("wrongBootsWidthSelectionSection");
const wrongBootsWidthSelection = document.getElementById("wrongBootsWidthSelection");

const defectDescriptionWrapper = document.getElementById("defectDescriptionWrapper");
const defectDescriptionTitle = document.getElementById("defectDescriptionTitle");
const defectDescriptionInput = document.getElementById("defectDescriptionInput");
const imageElements = Array.from(document.querySelectorAll(".productImage"));
const imageInputs = Array.from(document.querySelectorAll(".imageInput"));

const customerFirstNameInput = document.getElementById("customerFirstNameInput");
customerFirstNameInput.addEventListener("input", () => { allowNextSlideBtn(isCustomerInfoValid(false)) });
const customerLastNameInput = document.getElementById("customerLastNameInput");
customerLastNameInput.addEventListener("input", () => { allowNextSlideBtn(isCustomerInfoValid(false)) });
const customerEmailInput = document.getElementById("customerEmailInput");
customerEmailInput.addEventListener("input", () => { allowNextSlideBtn(isCustomerInfoValid(false)) });
const locationSelect = document.getElementById("locationSelect");
locationSelect.addEventListener("change", () => { allowNextSlideBtn(isCustomerInfoValid(false)) });

const firstNameRequiredP = document.getElementById("firstNameRequiredP");
const lastNameRequiredP = document.getElementById("lastNameRequiredP");
const emailRequiredP = document.getElementById("emailRequiredP");
const emailFormatInvalidP = document.getElementById("emailFormatInvalidP");
const locationRequiredP = document.getElementById("locationRequiredP");

const finalCheckRequestType = document.getElementById("finalCheckRequestType");
const finalCheckLowOnStockWarning = document.getElementById("finalCheckLowOnStockWarning");
const finalCheckOutOfStockWarning = document.getElementById("finalCheckOutOfStockWarning");
const finalCheckReturnIn = document.getElementById("finalCheckReturnIn");
const finalCheckReturnOutArrow = document.getElementById("finalCheckReturnOutArrow");
const finalCheckReturnOut = document.getElementById("finalCheckReturnOut");
const finalCheckReasonWrapper = document.getElementById("finalCheckReasonWrapper");
const finalCheckReason = document.getElementById("finalCheckReason");
const finalCheckFirstName = document.getElementById("finalCheckFirstName");
const finalCheckLastName = document.getElementById("finalCheckLastName");
const finalCheckEmail = document.getElementById("finalCheckEmail");
const finalCheckLocation = document.getElementById("finalCheckLocation");
const finalCheckImagesWrapper = document.getElementById("finalCheckImagesWrapper");
const finalCheckImages = document.getElementById("finalCheckImages");
const agreeTermsCheckboxInput = document.getElementById("agreeTermsCheckboxInput");

const requestTypeConfirmation = document.getElementById("requestTypeConfirmation");

const requestCreatedEmailP = document.getElementById("requestCreatedEmailP");
const requestFailedEmailP = document.getElementById("requestFailedEmailP");

const loader = document.getElementsByClassName("splash-screen")[0];

let nbOfSlides = 0;
let selectedItemIn = null;
let returnInSelectedSref1 = null;
let returnInSelectedSref2 = null;

let selectedItemOut = null;
let returnOutSelectedSref1 = null;
let returnOutSelectedSref2 = null;

const swiperPrevBtnClass = "swiper-button-prev"
const swiperNextBtnClass = "swiper-button-next"

const nextBtn = document.getElementById("nextBtn");
const sendBtn = document.getElementById("sendBtn");

sendBtn.addEventListener("click", post)

newModelSelect.addEventListener("change", newModelSelection);
boArtNewModelSelect.addEventListener("change", boArtNewModelSelection);

getStockArticles();
getArticles();
getAirports();

let swiperReturn = new Swiper(".swiper-returns", {
    // Optional parameters
    direction: "horizontal",
    loop: false,
    speed: 200,
    autoHeight: true,
    effect: "slide",
    allowSlideNext: false,
    allowTouchMove: false,
    effect: 'fade',
    fadeEffect: {
        crossFade: true
    },
    //allowSlidePrev: false,
    //allowTouchMove: false,
    // Navigation arrows
    navigation: {
        nextEl: "." + swiperNextBtnClass,
        prevEl: "." + swiperPrevBtnClass,
    },
    on: {
        slideChange: (swiper) => slideChange(swiper),
        beforeInit: () => { nbOfSlides = document.querySelector(".swiper-returns").querySelectorAll(".swiper-slide").length; },
        slideChangeTransitionStart: (swiper) => slideChangeTransitionStart(swiper),
        slideChangeTransitionEnd: (swiper) => slideChangeTransitionEnd(swiper)
    },
});

const swiperEl = swiperReturn.el;
const swiperPrevBtnEl = swiperEl.querySelector("." + swiperPrevBtnClass);
const swiperNextBtnEl = swiperEl.querySelector("." + swiperNextBtnClass);

Array.from(document.getElementsByClassName("finalCheckEditBtn")).forEach(btn => {
    btn.addEventListener("click", () => {
        const slideEl = document.getElementById(btn.dataset.slideId);
        if (!slideEl) console.log("No slide with the id '" + btn.dataset.slideId + "' was found")
        else {
            swiperReturn.slideTo(getIndexOfChild(slideEl));
        }
    })
});

agreeTermsCheckboxInput.addEventListener("change", () => {
    sendBtn.disabled = !agreeTermsCheckboxInput.checked;
});

function getStockArticles() {
    //show the loader
    loader.style.setProperty('display', 'flex', 'important');

    const prodUrl = royerApiBaseAddress + "return-exchange-warranty-request/air-canada-models-stock"
    const devUrl = royerApiLocalhostBaseAddress + "return-exchange-warranty-request/air-canada-models-stock"
    const getStockArticlesUrl = devMode ? devUrl : prodUrl;

    var myHeaders = new Headers();
    myHeaders.append('Authorization', "Basic TVZobGVsa3FScDk0TlI2NTFseXM6c2ZIUnpVT1FGcEcxclJ6WGx1bE0=");
    myHeaders.append('Content-Type', 'application/json');
    myHeaders.append('Content-Length', '0');

    let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow',
        scheme: 'https',
        mode: 'cors',
        cache: 'no-cache'
    };

    fetch(getStockArticlesUrl, requestOptions)
        .then(response => response.text())
        .then(result => {
            stockArticles = JSON.parse(result)
            //Hide the loader again
            loader.style.display = "";
        })
        .catch(error => {
            //Hide the loader again
            loader.style.display = "";
            console.log(error)
            //ADD ERROR MESSAGE LATER
        });
}

function getArticles() {
    const prodUrl = royerApiBaseAddress + "return-exchange-warranty-request/air-canada-models"
    const devUrl = royerApiLocalhostBaseAddress + "return-exchange-warranty-request/air-canada-models"
    const getArticlesUrl = devMode ? devUrl : prodUrl;

    var myHeaders = new Headers();
    myHeaders.append('Authorization', "Basic TVZobGVsa3FScDk0TlI2NTFseXM6c2ZIUnpVT1FGcEcxclJ6WGx1bE0=");
    myHeaders.append('Content-Type', 'application/json');
    myHeaders.append('Content-Length', '0');

    let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow',
        scheme: 'https',
        mode: 'cors',
        cache: 'no-cache'
    };

    fetch(getArticlesUrl, requestOptions)
        .then(response => response.text())
        .then(result => {
            articles = JSON.parse(result)
            articles.forEach(art => {
                if (art.return_in) {
                    const option = document.createElement("option");
                    option.classList.add("hideOptionIfDisabled")
                    option.value = art.ref;
                    option.innerText = art["label_" + Shopify.locale.toLowerCase()];
                    modelSelect.appendChild(option);
                }
                if (art.return_out) {
                    const option = document.createElement("option");
                    option.classList.add("hideOptionIfDisabled")
                    option.value = art.ref;
                    option.innerText = art["label_" + Shopify.locale.toLowerCase()];
                    newModelSelect.appendChild(option);
                    boArtNewModelSelect.appendChild(option.cloneNode(true));
                }

                if (!articles.some(art => !art.return_out)){
                    outOfStockWarningP.classList.add("d-none");
                }
                else{
                    outOfStockModelsSpan.innerText = articles.filter(art => !art.return_out).map(art => art.ref).join(", ");
                }
            });

        })
        .catch(error => {
            console.log(error)
            //ADD ERROR MESSAGE LATER
        });
}

function getAirports() {
    const prodUrl = royerApiBaseAddress + "return-exchange-warranty-request/air-canada-airports"
    const devUrl = royerApiLocalhostBaseAddress + "return-exchange-warranty-request/air-canada-airports"
    const getAirportsUrl = devMode ? devUrl : prodUrl;

    var myHeaders = new Headers();
    myHeaders.append('Authorization', "Basic TVZobGVsa3FScDk0TlI2NTFseXM6c2ZIUnpVT1FGcEcxclJ6WGx1bE0=");
    myHeaders.append('Content-Type', 'application/json');
    myHeaders.append('Content-Length', '0');

    let requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow',
        scheme: 'https',
        mode: 'cors',
        cache: 'no-cache'
    };

    fetch(getAirportsUrl, requestOptions)
        .then(response => response.text())
        .then(result => {
            airports = JSON.parse(result)
            airports.forEach(airport => {
                const airportOption = document.createElement("option");
                airportOption.value = airport.id;
                airportOption.innerText = (airport.code ? airport.code + " - " : "") + airport["short_name_" + Shopify.locale.toLowerCase()];
                locationSelect.appendChild(airportOption);
            });
        })
        .catch(error => {
            console.log(error)
            //ADD ERROR MESSAGE LATER
        });
}

function toBase64(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = reject;
    })
}

async function post() {
    //show the loader
    loader.style.setProperty('display', 'flex', 'important');

    const prodUrl = royerApiBaseAddress + "return-exchange-warranty-request/create-request-air-canada"
    const devUrl = royerApiLocalhostBaseAddress + "return-exchange-warranty-request/create-request-air-canada"

    const postUrl = devMode ? devUrl : prodUrl;

    const request = {
        first_name: customerFirstNameInput.value,
        last_name: customerLastNameInput.value,
        user_email: customerEmailInput?.value,
        location_id: parseInt(locationSelect.value),
        no_site: "001",
        type: returnType,
        defect: returnReason,
        defect_description: defectDescriptionInput.value,
        lang: Shopify.locale.toUpperCase(),
        items: [{ ref: selectedItemIn.ref, sref1: selectedItemIn.sref1, sref2: selectedItemIn.sref2, direction: 1 }],
        images: await Promise.all(imageInputs.map(async (imgInput) => {
            if (imgInput.files.length == 0) return null;
            return {
                name: imgInput.dataset.type,
                base64: await toBase64(imgInput.files[0])
            }
        }))
    };
    //If this is an exchange add the return out to the list of items
    if (returnType == "E" || returnType == "E-M" || returnType == "E-BO" || returnType == "W-BO") {
        request.items.push({ ref: selectedItemOut.ref, sref1: selectedItemOut.sref1, sref2: selectedItemOut.sref2, direction: 2 });
    }
    var myHeaders = new Headers();
    myHeaders.append('Authorization', "Basic TVZobGVsa3FScDk0TlI2NTFseXM6c2ZIUnpVT1FGcEcxclJ6WGx1bE0=");
    myHeaders.append('Content-Type', 'application/json');
    myHeaders.append('Content-Length', '0');

    let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        redirect: 'follow',
        scheme: 'https',
        mode: 'cors',
        cache: 'no-cache',
        body: JSON.stringify(request)
    };

    fetch(postUrl, requestOptions)
        .then(response => response.text())
        .then(result => {
            //Hide the loader again
            loader.style.display = "";
            let createRequestResult = JSON.parse(result);
            if (createRequestResult.request_created) {
                allowNextSlideBtn(true);
                requestCreatedEmailP.innerText = customerEmailInput.value;
                let returnTypeText = null;
                if (returnType == "R") returnTypeText = templatesWrapper.querySelector(".returnText").innerText
                if (returnType == "E" || returnType == "E-BO" || returnType == "E-M") returnTypeText = templatesWrapper.querySelector(".exchangeText").innerText
                if (returnType == "W" || returnType == "W-BO") returnTypeText = templatesWrapper.querySelector(".warrantyText").innerText
                requestTypeConfirmation.innerText = returnTypeText;
                swiperNextBtnEl.classList.remove("swiperBtn");
                swiperPrevBtnEl.classList.remove("swiperBtn");
                swiperReturn.slideTo(getIndexOfChild(requestCreatedSlide));
            }
            else {
                allowNextSlideBtn(true);
                swiperNextBtnEl.classList.remove("swiperBtn");
                swiperPrevBtnEl.classList.remove("swiperBtn");
                swiperReturn.slideTo(getIndexOfChild(requestFailedSlide));
            }
        })
        .catch(error => {
            //Hide the loader again
            loader.style.display = "";
            console.log(error)
            allowNextSlideBtn(true);
            swiperReturn.slideTo(getIndexOfChild(requestFailedSlide));
            swiperNextBtnEl.classList.remove("swiperBtn");
            swiperPrevBtnEl.classList.remove("swiperBtn");
            //ADD ERROR MESSAGE LATER
        });
}

function setupStep2(order) {
    const nbOfDaysSinceShipping = (new Date() - new Date(order.shipped_date)) / (1000 * 3600 * 24);

    const typeDivs = Array.from(typeSelectWrapper.children);
    if (nbOfDaysSinceShipping < maxDaysReturnExchange) {
        typeDivs.find(div => div.dataset.value == "R").classList.remove("disabled");
        typeDivs.find(div => div.dataset.value == "E").classList.remove("disabled");
    }
    else {
        typeDivs.find(div => div.dataset.value == "R").classList.add("disabled");
        typeDivs.find(div => div.dataset.value == "E").classList.add("disabled");
    }
    if (nbOfDaysSinceShipping < maxDaysWarranty) {
        typeDivs.find(div => div.dataset.value == "W").classList.remove("disabled");
    }
    else {
        typeDivs.find(div => div.dataset.value == "W").classList.add("disabled");
    }
}

function resetStep3In() {
    selectedItemIn = null;
    returnInSelectedSref1 = null;
    returnInSelectedSref2 = null;
    returnInSizeSelection.innerHTML = "";
    returnInWidthSelection.innerHTML = "";
}

function resetStep3Out() {
    selectedItemOut = null;
    returnOutSelectedSref1 = null;
    returnOutSelectedSref2 = null;
    boArtNewModelSelect.value = "";
    newModelSelect.value = "";
    exchangeSizeSelection.innerHTML = "";
    exchangeWidthSelection.innerHTML = "";
}

function typeSelectChange(type) {
    //If the type isn't disabled
    if (!Array.from(typeSelectWrapper.children).find(div => div.dataset.value == type).classList.contains("disabled")) {
        //Deselect selected item
        resetStep3Out();
        resetStep3In();

        selectedItemIn = null;
        returnInSelectedSref1 = null;
        returnInSelectedSref2 = null;
        selectedItemOut = null;
        returnOutSelectedSref1 = null;
        returnOutSelectedSref2 = null;

        modelSelect.value = "";
        returnType = type;
        Array.from(articleSelectionTitlesWrapper.children)
            .forEach(title =>
                title.dataset.types.split(",").includes(returnType) ? title.classList.remove("d-none") : title.classList.add("d-none")
            )
        allowNextSlideBtn(true);
        swiperReturn.slideNext();
    }
}

function fillArticleBox(articleBox, item, titleClass = yourModelTitleClass) {
    articleBox.innerHTML = createArticleElement(item, titleClass).outerHTML;
    articleBox.children[0].classList.remove("selectedReturnRow");
    articleBox.children[0].classList.add("noHover");
}

function modelSelectChange(e) {
    resetStep3In();
    resetStep3Out();

    selectedItemIn = stockArticles.find(article => article.ref == e.target.value);
    selectedItemOut = { ...selectedItemIn };
    returnOutSelectedSref1 = null;
    returnOutSelectedSref2 = null;

    const article = articles.find(art => art.ref == e.target.value);
    if (!article.return_out && returnType == "E") returnType = "E-BO";
    else if(!article.return_out && returnType == "W") returnType = "W-BO";
    else if (article.return_out && returnType == "E-BO") returnType = "E";
    else if (article.return_out && returnType == "W-BO") returnType = "W";

    allowNextSlideBtn(true);
    swiperReturn.slideTo(getIndexOfChild(returnInSizeSelectionSlide));
}

function returnTurnedExchanged() {
    returnType = "E";
    allowNextSlideBtn(true);

    selectedItemIn = selectedOrder.items.find(item => item.nun == crtSelectedRow.dataset.nun);
    selectedItemOut = { ...selectedItemIn };

    setupReturnOut();
    swiperReturn.slideTo(getIndexOfChild(exchangeSizeSelectionSlide));
}

function exchangeModelReason(el) {
    returnReason = el.dataset.type;
    allowNextSlideBtn(true);
    swiperReturn.slideNext();
}

function refundFullAmountClicked() {
    fillArticleBox(returnQuestionTwoArticleBox, selectedItemIn);
    allowNextSlideBtn(true);
    swiperReturn.slideTo(getIndexOfChild(returnQuestionTwoSlide));
}

function returnQuestionTwoClick(el) {
    const type = el.dataset.type;

    let shownChild = [];
    Array.from(returnQuestionThreeWrapper.children).forEach(child => {
        if (child.dataset.type == type) {
            shownChild.push(child);
            child.classList.remove("d-none");
        }
        else child.classList.add("d-none");
    });

    fillArticleBox(returnQuestionThreeArticleBox, selectedItemIn);

    allowNextSlideBtn(true);
    swiperReturn.slideTo(getIndexOfChild(returnQuestionThreeSlide));

    //If any of the child have show next button attribute then show the next btn
    shownChild.forEach(child => {
        if ("showNextBtn" in child.dataset) {
            swiperNextBtnEl.classList.add("swiperBtn")
            allowNextSlideBtn(true);
            //On next click send user to final check page
            swiperNextBtnEl.onclick = () => {
                const activeIdx = swiperReturn.activeIndex;
                const currentSlide = swiperReturn.slides[activeIdx];
                const otherTextArea = currentSlide.querySelector(".otherTextArea");
                if (otherTextArea) returnReason = child.dataset.type + "__:__" + otherTextArea.value;
                swiperReturn.slideTo(getIndexOfChild(finalCheckSlide));
            };
        }
        else {
            swiperNextBtnEl.classList.remove("swiperBtn");
            swiperNextBtnEl.onclick = null;
        }
    });
}

function returnQuestionThreeClick(el) {
    const type = el.dataset.type.split("_");
    const baseType = type[0];
    const lastType = type[1];

    if (lastType == "other") {
        fillArticleBox(returnQuestionThreeOtherArticleBox, selectedItemIn);
        returnQuestionThreeOtherTitle.innerText = returnQuestionTwoSlide.querySelector("div[data-type=" + baseType + "]")?.querySelector(".selectableDivText")?.innerText;
        allowNextSlideBtn(true);
        swiperReturn.slideTo(getIndexOfChild(returnQuestionThreeOtherSlide));
        swiperNextBtnEl.classList.add("swiperBtn")
        allowNextSlideBtn(true);
        swiperNextBtnEl.onclick = () => {
            const activeIdx = swiperReturn.activeIndex;
            const currentSlide = swiperReturn.slides[activeIdx];
            const otherTextArea = currentSlide.querySelector(".otherTextArea");
            if (otherTextArea) returnReason = el.dataset.type + "__:__" + otherTextArea.value;
            swiperReturn.slideTo(getIndexOfChild(finalCheckSlide));
        };
    }
    else {
        returnReason = el.dataset.type

        allowNextSlideBtn(true);
        swiperReturn.slideTo(getIndexOfChild(finalCheckSlide));
    }
}

function warrantyQuestionOneClick(el) {
    returnReason = el.dataset.type

    allowNextSlideBtn(true);
    swiperReturn.slideNext();
}

function setupReturnIn() {
    returnInSizeSelection.innerHTML = "";
    returnInWidthSelection.innerHTML = "";
    const possibleSref1 = [...new Set(selectedItemIn.stocks.map((item) => item.sref1))];
    const possibleSref2 = [...new Set(selectedItemIn.stocks.map((item) => item.sref2))];

    Array.from(returnInSizeSelectionSection.children).forEach(child => {
        if (!child.dataset.types || child.dataset.types == returnType) {
            child.classList.remove("d-none");
        }
        else child.classList.add("d-none");
    });

    if (possibleSref2.length < 2) returnInSizeSelectionSection.classList.add("d-none");
    else returnInSizeSelectionSection.classList.remove("d-none");

    if (possibleSref1.length < 2) returnInWidthSelectionSection.classList.add("d-none");
    else returnInWidthSelectionSection.classList.remove("d-none");
    possibleSref1.forEach(sref1 => {
        let variantBtn = document.createElement("button");
        variantBtn.classList.add("variantBtn");
        //Automaticly select the option if it's the only one
        if (possibleSref1.length == 1) {
            variantBtn.classList.add("selected")
            selectedItemIn.sref1 = possibleSref1[0];
            if (returnType == "W") selectedItemOut.sref1 = selectedItemIn.sref1;
            returnInSelectedSref1 = variantBtn;
        };
        variantBtn.dataset.value = sref1;
        variantBtn.innerHTML = sref1;
        variantBtn.onclick = returnInNewSref1Selected;

        returnInWidthSelection.appendChild(variantBtn);
    });

    possibleSref2.forEach(sref2 => {
        let variantBtn = document.createElement("button");
        variantBtn.classList.add("variantBtn");
        //Automaticly select the option if it's the only one
        if (possibleSref2.length == 1) {
            variantBtn.classList.add("selected");
            selectedItemIn.sref2 = possibleSref2[0];
            if (returnType == "W") selectedItemOut.sref2 = selectedItemIn.sref2;
            returnInSelectedSref2 = variantBtn;
        }

        variantBtn.dataset.value = sref2;
        variantBtn.innerHTML = sref2;
        variantBtn.onclick = returnInNewSref2Selected;

        returnInSizeSelection.appendChild(variantBtn);
    });
    fillArticleBox(returnInSizeSelectionArticleBox, selectedItemIn);
    //Force the swiper to update the height after showing the size select section
    swiperReturn.update();
}

function boArtNewModelSelection(event) {
    const newModelRef = event.target.value;

    selectedItemOut = stockArticles.find(article => article.ref == newModelRef);
    returnOutSelectedSref1 = null;
    returnOutSelectedSref2 = null;

    //Wipe old information if any
    boArtNewModelSelectWrapper.innerHTML = "";

    //Add the info for the selected new model
    boArtNewModelSelectWrapper.appendChild(createNewModelInfoElement(articles.find(article => article.ref == newModelRef)));

    allowNextSlideBtn(true);
    swiperNextBtnEl.classList.add("swiperBtn");
}

function newModelSelection(event) {
    const newModelRef = event.target.value;

    selectedItemOut = stockArticles.find(article => article.ref == newModelRef);
    returnOutSelectedSref1 = null;
    returnOutSelectedSref2 = null;

    //Wipe old information if any
    newModelSelectWrapper.innerHTML = "";

    //Add the info for the selected new model
    newModelSelectWrapper.appendChild(createNewModelInfoElement(articles.find(article => article.ref == newModelRef)));

    allowNextSlideBtn(true);
    swiperNextBtnEl.classList.add("swiperBtn");
}

function setupReturnOut() {
    exchangeSizeSelection.innerHTML = "";
    exchangeWidthSelection.innerHTML = "";
    const possibleSref1 = [...new Set(selectedItemOut.stocks.map((item) => item.sref1))];
    const possibleSref2 = [...new Set(selectedItemOut.stocks.map((item) => item.sref2))];

    if (possibleSref2.length < 2) exchangeSizeSelectionSection.classList.add("d-none");
    else exchangeSizeSelectionSection.classList.remove("d-none");

    if (possibleSref1.length < 2) exchangeWidthSelectionSection.classList.add("d-none");
    else exchangeWidthSelectionSection.classList.remove("d-none");

    possibleSref1.forEach(sref1 => {
        let variantBtn = document.createElement("button");
        variantBtn.classList.add("variantBtn");
        variantBtn.dataset.value = sref1;
        variantBtn.innerHTML = sref1;
        variantBtn.onclick = returnOutNewSref1Selected;
        //Automaticly select the option if it's the only one
        if (possibleSref1.length == 1) {
            variantBtn.classList.add("selected")
            returnOutSelectedSref1 = variantBtn;
            selectedItemOut.sref1 = possibleSref1[0];
        };

        exchangeWidthSelection.appendChild(variantBtn);
    });

    possibleSref2.forEach(sref2 => {
        let variantBtn = document.createElement("button");
        variantBtn.classList.add("variantBtn");
        //If the sref1 currently selected and the current size button beeing created are the same as the selected item and the model is the same disable the button
        if (selectedItemOut.ref == selectedItemIn.ref && selectedItemOut.sref1 == selectedItemIn.sref1 && sref2 == selectedItemIn.sref2) {
            variantBtn.disabled = true;
            variantBtn.title = "";
        }
        variantBtn.dataset.value = sref2;
        variantBtn.innerHTML = sref2;
        variantBtn.onclick = returnOutNewSref2Selected;
        //Automaticly select the option if it's the only one
        if (possibleSref2.length == 1) {
            variantBtn.classList.add("selected");
            returnOutSelectedSref2 = variantBtn;
            selectedItemOut.sref2 = possibleSref2[0];
        }

        exchangeSizeSelection.appendChild(variantBtn);
    });
    //Disabled for air canada because we make the boots on demand
    //updateSizeBtnStockStyle();

    fillArticleBox(exchangeSizeSelectionArticleBox, selectedItemOut.ref == selectedItemIn.ref ? selectedItemIn : selectedItemOut, selectedItemOut.ref == selectedItemIn.ref ? yourModelTitleClass : newModelTitleClass);
    //Force the swiper to update the height after showing the size select section
    swiperReturn.update();
}

function returnInNewSref1Selected(e) {
    if (returnInSelectedSref1) returnInSelectedSref1.classList.remove("selected");
    returnInSelectedSref1 = e.target.closest("button");
    returnInSelectedSref1.classList.add("selected");

    selectedItemIn.sref1 = returnInSelectedSref1.dataset.value;
    if (returnType == "W") selectedItemOut.sref1 = selectedItemIn.sref1;
  
    if (checkReturnInSelection()) {
        swiperNextBtnEl.classList.add("swiperBtn")
        allowNextSlideBtn(true);
    }
}
function returnInNewSref2Selected(e) {
    if (returnInSelectedSref2) returnInSelectedSref2.classList.remove("selected");
    returnInSelectedSref2 = e.target.closest("button");
    returnInSelectedSref2.classList.add("selected");

    selectedItemIn.sref2 = returnInSelectedSref2.dataset.value;
    if (returnType == "W") selectedItemOut.sref2 = selectedItemIn.sref2;
  
    if (checkReturnInSelection()) {
        swiperNextBtnEl.classList.add("swiperBtn")
        allowNextSlideBtn(true);
    }
}

function returnOutNewSref1Selected(e) {
    if (returnOutSelectedSref1) returnOutSelectedSref1.classList.remove("selected");
    returnOutSelectedSref1 = e.target.closest("button");
    returnOutSelectedSref1.classList.add("selected");

    selectedItemOut.sref1 = returnOutSelectedSref1.dataset.value;

    //Disabled for air canada because we make the boots on demand
    //updateSizeBtnStockStyle();

    if (checkExchangeSelection()) {
        swiperNextBtnEl.classList.add("swiperBtn")
        allowNextSlideBtn(true);
    }
}

function returnOutNewSref2Selected(e) {
    if (returnOutSelectedSref2) returnOutSelectedSref2.classList.remove("selected");
    returnOutSelectedSref2 = e.target.closest("button");
    returnOutSelectedSref2.classList.add("selected");

    selectedItemOut.sref2 = returnOutSelectedSref2.dataset.value;

    //Disabled for air canada because we make the boots on demand
    //updateSizeBtnStockStyle();

    if (checkExchangeSelection()) {
        swiperNextBtnEl.classList.add("swiperBtn")
        allowNextSlideBtn(true);
    }
}

function checkReturnInSelection() {
    if (returnInSelectedSref2 && returnInSelectedSref1) {
        const stockObj = selectedItemIn.stocks.find(stock => stock.ref == selectedItemIn.ref && stock.sref1 == returnInSelectedSref1.dataset.value && stock.sref2 == returnInSelectedSref2.dataset.value)
        if (stockObj) return true;
        else return false;
    }
}
function checkExchangeSelection() {
    if (returnOutSelectedSref2 && returnOutSelectedSref1) {
        const stockObj = selectedItemOut.stocks.find(stock => stock.ref == selectedItemOut.ref && stock.sref1 == returnOutSelectedSref1.dataset.value && stock.sref2 == returnOutSelectedSref2.dataset.value)
        if (stockObj) return true;
        else return false;
    }
}

function updateSizeBtnStockStyle() {
    const stockTitlePrefix = templatesWrapper.querySelector(".articleStockAvailable").innerText;
    const sref2Btns = exchangeSizeSelection.querySelectorAll(".variantBtn");
    const sref1Btns = exchangeWidthSelection.querySelectorAll(".variantBtn");

    if (returnOutSelectedSref1) {
        sref2Btns.forEach(btn => {
            const stockObj = selectedItemOut.stocks.find(stock => stock.ref == selectedItemOut.ref && stock.sref1 == selectedItemOut.sref1 && stock.sref2 == btn.dataset.value)
            if (stockObj) {
                btn.disabled = selectedItemIn.ref == selectedItemOut.ref && selectedItemOut.sref1 == selectedItemOut.sref1 && btn.dataset.value == selectedItemOut.sref2;
                const stock = stockObj.stqte - stockObj.resqte;
                btn.title = stockTitlePrefix + (stock < 0 ? 0 : stock);
                btn.classList.remove("noStocks");
                btn.classList.remove("lowStocks");
                if (stock <= 0) btn.classList.add("noStocks");
                else if (stock < lowStockTreshold) btn.classList.add("lowStocks");
            }
            else {
                btn.disabled = true;
                btn.title = "";
            }
        });
    }
    else {
        sref2Btns.forEach(btn => {
            btn.classList.remove("noStocks");
            btn.classList.remove("lowStocks");
            btn.title = "";
        });
    }
    if (returnOutSelectedSref2) {
        sref1Btns.forEach(btn => {
            const stockObj = selectedItemOut.stocks.find(stock => stock.ref == selectedItemOut.ref && stock.sref1 == btn.dataset.value && stock.sref2 == selectedItemOut.sref2)
            if (stockObj) {
                btn.disabled = selectedItemIn.ref == selectedItemOut.ref && selectedItemOut.sref2 == selectedItemOut.sref2 && btn.dataset.value == selectedItemOut.sref1;
                const stock = stockObj.stqte - stockObj.resqte;
                btn.title = stockTitlePrefix + (stock < 0 ? 0 : stock);
                btn.classList.remove("noStocks");
                btn.classList.remove("lowStocks");
                if (stock <= 0) btn.classList.add("noStocks");
                else if (stock < lowStockTreshold) btn.classList.add("lowStocks");
            }
            else {
                btn.disabled = true;
                btn.title = "";
            }
        });
    }
    else {
        sref1Btns.forEach(btn => {
            btn.classList.remove("noStocks");
            btn.classList.remove("lowStocks");
            btn.title = "";
        });
    }
}

function setupWrongBootPicking(selectedItemIn) {
    fillArticleBox(wrongBootsSizeSelectionArticleBox, selectedItemIn);
}

function changeImageBtnClicked(btnEl) {
    const fileInput = btnEl.querySelector("input[type='file']");
    fileInput.click();
}

function imageChange(fileInput) {
    if (fileInput.files && fileInput.files[0]) {
        let reader = new FileReader();
        const fileName = fileInput.files[0].name;
        reader.onload = (e) => {
            const imageWrapper = fileInput.closest("button");
            const imgEl = imageWrapper.querySelector("img");
            imgEl.src = e.target.result;
            //Alt text is set to the file name without the extension
            imgEl.alt = fileName.split(".")[0]

            imageWrapper.classList.remove("emptyImage")

            //if all the images are now filled allow post
            let allImageFilled = imageInputs.every(input => input.files.length != 0);
            allowNextSlideBtn(allImageFilled);
            if (allImageFilled) {
                swiperNextBtnEl.classList.add("swiperBtn")
                swiperNextBtnEl.onclick = () => {
                    allowNextSlideBtn(true);
                };
            }
        };
        reader.readAsDataURL(fileInput.files[0]);
    }
}

function createArticleElement(item, titleClass) {
    let row = document.createElement("div");
    row.classList.add("articleRow");
    row.dataset.nun = item.nun;

    let imgWrapperDiv = document.createElement("div");
    let itemImg = document.createElement("img");
    itemImg.src = baseCdnPath + item.ref + "_SIDE.jpg";
    itemImg.classList.add("articleImg");
    imgWrapperDiv.classList.add("articleImgWrapperDiv");
    imgWrapperDiv.appendChild(itemImg);

    let articleWrapperDiv = document.createElement("div");
    let refDiv = document.createElement("div");
    refDiv.innerHTML = "<b>" + templatesWrapper.querySelector("." + titleClass).innerText + "</b>" + item.ref + (item.sref1 ? "-" : "") + item.sref1 + (item.sref2 ? "-" : "") + item.sref2;
    refDiv.classList.add("articleRefWrapperDiv");

    let priceDiv = document.createElement("div");
    if (item.price) {
        priceDiv.innerHTML = "$" + item.price.toFixed(2) + " " + item.dev;
        priceDiv.classList.add("articlePriceWrapperDiv")
    }
    let nunDiv = document.createElement("div");
    if (item.nun) {
        nunDiv.innerHTML = "NUN : " + item.nun;
        nunDiv.classList.add("articleNunWrapperDiv");
    }

    row.appendChild(imgWrapperDiv);
    articleWrapperDiv.appendChild(refDiv);
    articleWrapperDiv.appendChild(priceDiv);
    articleWrapperDiv.appendChild(nunDiv);
    row.appendChild(articleWrapperDiv);

    if (item.returned || item.exchanged || item.warrantied) {
        row.classList.add("articleNotAvailable");
        row.appendChild(templatesWrapper.querySelector(".articleInfoEllipse").cloneNode(true));

        if (item.returned) row.appendChild(templatesWrapper.querySelector(".articleReturnedPopup").cloneNode(true));
        else if (item.exchanged) row.appendChild(templatesWrapper.querySelector(".articleExchangedPopup").cloneNode(true));
        else if (item.warrantied) row.appendChild(templatesWrapper.querySelector(".articleWarrantiedPopup").cloneNode(true));
    }
    return row;
}

function createNewModelInfoElement(article) {
    const infoWrapper = document.createElement("div");
    infoWrapper.classList.add("newModelSelectItem");
    infoWrapper.dataset.ref = article.ref;

    const leftWrapper = document.createElement("div");

    const imageWrapper = document.createElement("div");
    imageWrapper.classList.add("articleImgWrapperDiv")

    const imageEl = document.createElement("img");
    imageEl.classList.add("articleImg");
    imageEl.src = `https://royer.com/cdn/shop/files/${article.ref.toUpperCase()}_SIDE.jpg`;

    imageWrapper.appendChild(imageEl);
    leftWrapper.appendChild(imageWrapper);

    const refWrapper = document.createElement("div");
    refWrapper.classList.add("articleRefWrapperDiv");
    const refHeader = document.createElement("h4");
    refHeader.innerText = article.ref.toUpperCase();

    refWrapper.appendChild(refHeader);
    leftWrapper.appendChild(refWrapper);

    const rightWrapper = document.createElement("div");
    rightWrapper.classList.add("product-description-exchange");

    const featuresHeader = document.createElement("h5");
    featuresHeader.innerText = templatesWrapper.querySelector(".featuresText").innerText;
    rightWrapper.appendChild(featuresHeader);

    article.features.filter(feat => feat).forEach(feat => {
        const featureWrapper = document.createElement("div");
        featureWrapper.classList.add("product-description-exchange-item");

        const dot = document.createElement("div");
        dot.classList.add("exchange-dot");
        featureWrapper.appendChild(dot);

        const text = document.createElement("p");
        text.innerText = feat["label_" + Shopify.locale.toLowerCase()];
        featureWrapper.appendChild(text);

        rightWrapper.appendChild(featureWrapper);
    });

    infoWrapper.appendChild(leftWrapper);
    infoWrapper.appendChild(rightWrapper);

    return infoWrapper;
}

function isCustomerInfoValid(updateErrorMessages = true) {
    let validInformation = true;
    if (customerFirstNameInput.value) {
        if (updateErrorMessages) firstNameRequiredP.classList.add("invisible")
    }
    else {
        if (updateErrorMessages) firstNameRequiredP.classList.remove("invisible")
        validInformation = false;
    }
    if (customerLastNameInput.value) {
        if (updateErrorMessages) lastNameRequiredP.classList.add("invisible")
    }
    else {
        if (updateErrorMessages) lastNameRequiredP.classList.remove("invisible")
        validInformation = false;
    }
    if (customerEmailInput.value) {
        if (updateErrorMessages) {
            emailRequiredP.classList.add("invisible");
            emailFormatInvalidP.classList.add("d-none");
        }
    }
    else {
        if (updateErrorMessages) {
            emailRequiredP.classList.remove("d-none");
            emailRequiredP.classList.remove("invisible");
            emailFormatInvalidP.classList.add("d-none");
        }
        validInformation = false;
    }
    if (customerEmailInput.value && !(new RegExp(/[^@ \t\r\n]+@[^@ \t\r\n]+\.[^@ \t\r\n]+/).test(customerEmailInput.value))) {
        if (updateErrorMessages) {
            emailRequiredP.classList.add("d-none")
            emailFormatInvalidP.classList.remove("d-none")
            emailFormatInvalidP.classList.remove("invisible")
        }
        validInformation = false;
    }
    else {
        if (updateErrorMessages) emailFormatInvalidP.classList.add("invisible")
    }
    if (locationSelect.value) {
        if (updateErrorMessages) locationRequiredP.classList.add("invisible")
    }
    else {
        if (updateErrorMessages) locationRequiredP.classList.remove("invisible")
        validInformation = false;
    }
    return validInformation;
}

function fillFinalCheck() {
    agreeTermsCheckboxInput.checked = false;
    swiperNextBtnEl.classList.add("swiperBtn");
    swiperNextBtnEl.classList.remove("swiper-button-disabled");
    nextBtn.classList.add("d-none");
    sendBtn.classList.remove("d-none");
    sendBtn.disabled = true;
    allowNextSlideBtn(false);

    const returnOutSref1 = returnOutSelectedSref1?.dataset.value;
    const returnOutSref2 = returnOutSelectedSref2?.dataset.value;
    //Request type
    Array.from(finalCheckRequestType.children).forEach(typeEl => {
        if (typeEl.dataset.type == returnType) typeEl.classList.remove("d-none")
        else typeEl.classList.add("d-none")
    });

    //Low / out stock warning for exchange
    finalCheckLowOnStockWarning.classList.add("d-none");
    finalCheckOutOfStockWarning.classList.add("d-none");
    if (returnOutSref1 && returnOutSref2) {
        const stockArticleOut = selectedItemOut.stocks.find(stock => stock.ref == selectedItemOut.ref && stock.sref1 == returnOutSref1 && stock.sref2 == returnOutSref2);
        const avStock = stockArticleOut.stqte - stockArticleOut.resqte;
        if (avStock <= 0) finalCheckOutOfStockWarning.classList.remove("d-none");
        else if (avStock < lowStockTreshold) finalCheckLowOnStockWarning.classList.remove("d-none");
    }

    //Request articles involved
    finalCheckReturnIn.innerHTML = "";
    finalCheckReturnOut.innerHTML = "";

    const articleInBox = createArticleElement(selectedItemIn, yourModelTitleClass);
    articleInBox.classList.add("noHover");
    articleInBox.classList.add("border-0");

    finalCheckReturnIn.appendChild(articleInBox);

    if (selectedItemOut.ref != selectedItemIn.ref || selectedItemOut.sref1 != selectedItemIn.sref1 || selectedItemOut.sref2 != selectedItemIn.sref2) {
        const articlOutBox = createArticleElement({ ref: selectedItemOut.ref, sref1: returnOutSref1, sref2: returnOutSref2 }, newModelTitleClass);
        articlOutBox.classList.add("noHover");
        articlOutBox.classList.add("border-0");

        const yourModelText = templatesWrapper.querySelector(".YourModelText").innerHTML;
        const innerTextOut = articlOutBox.querySelector(".articleRefWrapperDiv");
        const requestedModelText = templatesWrapper.querySelector(".YourRequestedModelText").innerHTML;
        innerTextOut.innerHTML = innerTextOut.innerHTML.replaceAll(yourModelText, requestedModelText);

        finalCheckReturnOut.appendChild(articlOutBox);
        finalCheckReturnOutArrow.classList.remove("d-none");
    }
    else finalCheckReturnOutArrow.classList.add("d-none");

    //Reason
    const returnTypeWithReason = ["R", "R-W", "W", 'W-BO', "E-M"];
    if (returnTypeWithReason.includes(returnType)) {
        finalCheckReasonWrapper.classList.remove("d-none");
        const splitReasonWithOther = returnReason.split("__:__");
        let secondQuestionPrefix = splitReasonWithOther[0];
        const otherReason = splitReasonWithOther[1];

        const prefixSplit = secondQuestionPrefix.split("_");
        const firstQuestionPrefix = prefixSplit[0];
        if (firstQuestionPrefix == secondQuestionPrefix) secondQuestionPrefix = null;
        let reason = "";

        if (returnType == "R" || returnType == "R-W") {
            if (firstQuestionPrefix) reason += "<b>" + returnQuestionTwoSlide.querySelector("div[data-type=" + firstQuestionPrefix + "]")?.querySelector(".selectableDivText")?.innerText;
            if (secondQuestionPrefix) reason += " : " + returnQuestionThreeSlide.querySelector("div[data-type=" + secondQuestionPrefix + "]")?.querySelector(".selectableDivText")?.innerText + "</b><br />";
            else reason += "</b><br />"
            if (otherReason) reason += otherReason;
        }
        else if (returnType == "W" || returnType == "W-BO") {
            if (firstQuestionPrefix) reason += "<b>" + warrantyQuestionOneSlide.querySelector("div[data-type=" + firstQuestionPrefix + "]")?.querySelector(".selectableDivText")?.innerText + "</b><br />";
            if (defectDescriptionInput.value) reason += defectDescriptionInput.value;
        }
        else if (returnType == "E-M") {
            reason += "<b>" + exchangeModelReasonSlide.querySelector("div[data-type=" + returnReason + "]")?.querySelector(".selectableDivText")?.innerText + "</b><br />";
        }

        finalCheckReason.innerHTML = reason;
    }
    else finalCheckReasonWrapper.classList.add("d-none");

    finalCheckFirstName.innerText = customerFirstNameInput.value;
    finalCheckLastName.innerText = customerLastNameInput.value;
    finalCheckEmail.innerText = customerEmailInput.value;
    finalCheckLocation.innerText = Array.from(locationSelect.children).find(option => option.value == locationSelect.value).innerText;

    //Images
    const returnTypeWithImages = [];
    if (returnTypeWithImages.includes(returnType)) {
        finalCheckImagesWrapper.classList.remove("d-none");
        finalCheckImages.innerHTML = "";
        imageElements.forEach(imageEl => {
            const container = document.createElement("div");
            container.classList.add("finalCheckImageContainer");
            container.appendChild(imageEl.cloneNode(true));

            finalCheckImages.appendChild(container);
        });
    }
    else finalCheckImagesWrapper.classList.add("d-none");
}

function slideChangeTransitionStart(swiper) {
    const previousIdx = swiper.previousIndex;
    const activeIdx = swiper.activeIndex;

    const prevSlide = swiper.slides[previousIdx];
    const prevSlideFamilies = prevSlide.dataset.slide_family.split(",");

    //If the slide isn't valid for the current type chosen continue to next valid one
    let newIdx = activeIdx;
    let newSlide = swiper.slides[activeIdx];
    let newSlideFamilies = newSlide.dataset.slide_family.split(",");
    while (!(newIdx == 0 || newIdx == swiper.slides.length - 1 || newSlideFamilies.includes("common") || newSlideFamilies.includes(returnType))) {
        newSlide = swiper.slides[previousIdx > activeIdx ? --newIdx : ++newIdx];
        newSlideFamilies = newSlide.dataset.slide_family.split(",");
    }
    if (newIdx != activeIdx) {
        swiper.allowSlideNext = true;
        swiper.slideTo(newIdx);
        return;
    }
    const indexes = [previousIdx, newIdx];

    let lowerCutOff;
    let upperCutOff;
    //If the slide it was currently on is wrong then also hide that slide
    if (!prevSlideFamilies.includes("common") && !prevSlideFamilies.includes(returnType)) {
        lowerCutOff = Math.min(...indexes);
        upperCutOff = Math.max(...indexes);

        if (previousIdx > activeIdx) {
            lowerCutOff++;
            upperCutOff++;
        }
    }
    else {
        lowerCutOff = Math.min(...indexes) + 1;
        upperCutOff = Math.max(...indexes);
    }

    swiper.slides.slice(lowerCutOff, upperCutOff).forEach(slide => { slide.classList.add("invisible") });
}

function slideChange(swiper) {
    //By default use next button not send
    nextBtn.classList.remove("d-none");
    sendBtn.classList.add("d-none");

    document.body.scrollIntoView();

    const previousIdx = swiper.previousIndex;
    const activeIdx = swiper.activeIndex;
    const currentSlide = swiper.slides[activeIdx];

    swiperNextBtnEl.classList.remove("swiperBtn")
    swiperNextBtnEl.onclick = null;

    //Hide element not from the current type
    if (returnType) {
        currentSlide.querySelectorAll("*").forEach(child => {
            if (child.dataset.types) {
                if (child.dataset.types.split(",").includes(returnType)) {
                    child.classList.remove("d-none");
                }
                else child.classList.add("d-none");
            }
        });
    }

    if (currentSlide == articleSelectionSlide) {
        if (modelSelect.value) {
            swiperNextBtnEl.classList.add("swiperBtn")
            allowNextSlideBtn(true);
        }
        else {
            swiperNextBtnEl.classList.remove("swiperBtn")
            allowNextSlideBtn(false);
        }
    }
    else if (currentSlide == returnInSizeSelectionSlide) {
        if (checkReturnInSelection()) {
            swiperNextBtnEl.classList.add("swiperBtn")
            allowNextSlideBtn(true);
        }
        else {
            swiperNextBtnEl.classList.remove("swiperBtn")
            allowNextSlideBtn(false);
            setupReturnIn();
        }
    }
    else if (currentSlide == boArtExchangeModelSelectionSlide){
        fillArticleBox(boArtExchangeModelSelectionArticleBox,selectedItemIn);

        Array.from(boArtNewModelSelect.children).forEach(option => {
            if (option.value == selectedItemIn.ref) {
                option.disabled = true;
                option.classList.add("d-none");
            }
            else {
                option.disabled = false;
                option.classList.remove("d-none");
            }
        });
        const selectedNewModelInfo = boArtNewModelSelectWrapper.querySelector(".newModelSelectItem");
        if (selectedItemOut?.ref == selectedItemIn?.ref || boArtNewModelSelect.value == "") {
            //Wipe old information if any
            boArtNewModelSelectWrapper.innerHTML = "";
        }
        if (selectedItemOut?.ref && selectedItemOut?.ref != selectedItemIn?.ref && (!selectedNewModelInfo || selectedNewModelInfo.dataset.ref != selectedItemOut.ref)) {
            //Wipe old information if any
            boArtNewModelSelectWrapper.innerHTML = "";
            //Add the info for the selected new model
            boArtNewModelSelectWrapper.appendChild(createNewModelInfoElement(articles.find(article => article.ref == selectedItemOut?.ref)));
        }
        //If a new model is currently selected allow next button
        if (selectedItemOut?.ref != selectedItemIn?.ref) {
            swiperNextBtnEl.classList.add("swiperBtn")
            allowNextSlideBtn(true);
        }
    }
    else if (currentSlide == exchangeModelSelectionSlide) {
        fillArticleBox(exchangeModelSelectionArticleBox, selectedItemIn);

        Array.from(newModelSelect.children).forEach(option => {
            if (option.value == selectedItemIn.ref) {
                option.disabled = true;
                option.classList.add("d-none");
            }
            else {
                option.disabled = false;
                option.classList.remove("d-none");
            }
        });
        const selectedNewModelInfo = newModelSelectWrapper.querySelector(".newModelSelectItem");
        if (selectedItemOut?.ref == selectedItemIn?.ref || newModelSelect.value == "") {
            //Wipe old information if any
            newModelSelectWrapper.innerHTML = "";
        }
        if (selectedItemOut?.ref && selectedItemOut?.ref != selectedItemIn?.ref && (!selectedNewModelInfo || selectedNewModelInfo.dataset.ref != selectedItemOut.ref)) {
            //Wipe old information if any
            newModelSelectWrapper.innerHTML = "";
            //Add the info for the selected new model
            newModelSelectWrapper.appendChild(createNewModelInfoElement(articles.find(article => article.ref == selectedItemOut?.ref)));
        }
        //If a new model is currently selected allow next button
        if (selectedItemOut?.ref != selectedItemIn?.ref) {
            swiperNextBtnEl.classList.add("swiperBtn")
            allowNextSlideBtn(true);
        }

    }
    else if (currentSlide == exchangeSizeSelectionSlide) {
        if (checkExchangeSelection()) {
            swiperNextBtnEl.classList.add("swiperBtn")
            allowNextSlideBtn(true);
        }
        else {
            setupReturnOut();
        }
    }
    else if (currentSlide == exchangeModelReasonSlide) {
        fillArticleBox(exchangeModelReasonArticleBox, selectedItemOut, newModelTitleClass)
    }
    else if (currentSlide == warrantyQuestionOneSlide) {
        fillArticleBox(warrantyQuestionOneArticleBox, selectedItemIn);
        allowNextSlideBtn(false);
    }
    else if (currentSlide == imagesSlide) {
        fillArticleBox(imageArticleBox, selectedItemIn);
        if (returnType == "W" || returnType == "W-BO") {
            defectDescriptionWrapper.classList.remove("d-none");
            defectDescriptionTitle.innerText = warrantyQuestionOneSlide.querySelector("div[data-type=" + returnReason + "]")?.querySelector(".selectableDivText")?.innerText
        }
        else {
            defectDescriptionWrapper.classList.add("d-none");
        }
        swiperNextBtnEl.classList.add("swiperBtn")
        allowNextSlideBtn(true);
    }
    else if (currentSlide == customerInformationSlide) {
        allowNextSlideBtn(isCustomerInfoValid(false));
        swiperNextBtnEl.classList.add("swiperBtn")
        swiperNextBtnEl.onclick = () => {
            if (isCustomerInfoValid(true)) {
                allowNextSlideBtn(true);
                swiperReturn.slideNext();
            }
            else {
                //play a shaking animation to indicate that the user needs to fill the information
                currentSlide.classList.add("errorShakeAnimation");
                currentSlide.addEventListener("animationend", () => {
                    currentSlide.classList.remove("errorShakeAnimation");
                });
            }
        };
    }
    else if (currentSlide == finalCheckSlide) {
        fillFinalCheck();
    }
}

function slideChangeTransitionEnd(swiper) {
    const previousIdx = swiper.previousIndex;
    const activeIdx = swiper.activeIndex;
    const indexes = [previousIdx, activeIdx];
    const prevSlide = swiper.slides[previousIdx];
    const prevSlideFamilies = prevSlide.dataset.slide_family.split(",");

    let lowerCutOff;
    let upperCutOff;
    //If the slide it was currently on is wrong then also hide that slide
    if (!prevSlideFamilies.includes("common") && !prevSlideFamilies.includes(returnType)) {
        lowerCutOff = Math.min(...indexes);
        upperCutOff = Math.max(...indexes);

        if (previousIdx > activeIdx) {
            lowerCutOff++;
            upperCutOff++;
        }
    }
    else {
        lowerCutOff = Math.min(...indexes) + 1;
        upperCutOff = Math.max(...indexes);
    }

    swiper.slides.slice(lowerCutOff, upperCutOff).forEach(slide => { slide.classList.remove("invisible") });
}

function allowNextSlideBtn(allow) {
    swiperReturn.allowSlideNext = allow;
}

function scrollToCenterOfEl(el, smooth = true) {
    const rect = el.getBoundingClientRect();
    const top = (rect.top + window.scrollY) - (screen.height / 2) + (rect.height / 2);
    window.scroll({
        top: top,
        behavior: smooth ? 'smooth' : 'instant'
    });
}

function splitLastOccurrence(str, substring) {
    const lastIndex = str.lastIndexOf(substring);

    const before = str.slice(0, lastIndex);

    const after = str.slice(lastIndex + 1);

    return [before, after];
}

function getIndexOfChild(el) {
    return [].indexOf.call(el.parentNode.children, el);
}